import React from 'react';
import PropTypes from 'prop-types';
import { useAuth } from 'hooks/useAuth/useAuth';
import { useTranslation } from 'react-i18next';
import { Button, Spacer } from '@ontruck/orc';
import Modal from 'components/Modal';

const TermsAndConditionsModal = ({
  className,
  onAccept,
  canCancel,
  isShowing,
  tcLink
}) => {
  const { t } = useTranslation('Login');
  const { signout } = useAuth();

  const onCancel = () => signout();

  return (
    <Modal
      className={className}
      isShowing={isShowing}
      hide={onCancel}
      showCloseButton={false}
    >
      <div
        className="terms-and-conditions-modal__content"
        data-testid="terms-and-conditions-modal"
      >
        <div className="terms-and-conditions-modal__title">{t('tc')}</div>
        <Spacer mTop="S" mBottom="L">
          <span>
            {t('tc_msg1')}
            <a
              href={tcLink}
              rel="noopener noreferrer"
              target="_blank"
              className="terms-and-conditions-modal__link"
            >
              {t('tc_link')}
            </a>
            {t('tc_msg2')}
          </span>
        </Spacer>
        <div className="terms-and-conditions-modal__buttons">
          {canCancel && (
            <Button
              ghost
              text={t('tc_cancel')}
              onClick={onCancel}
              data-testid="terms-and-conditions-modal__cancel"
            />
          )}
          <Button
            text={t('tc_accept')}
            onClick={onAccept}
            className="terms-and-conditions-modal__accept"
            data-testid="terms-and-conditions-modal__accept"
          />
        </div>
      </div>
    </Modal>
  );
};

TermsAndConditionsModal.defaultProps = {
  canCancel: true,
  isShowing: false
};

TermsAndConditionsModal.propTypes = {
  className: PropTypes.string,
  onAccept: PropTypes.func.isRequired,
  canCancel: PropTypes.bool,
  isShowing: PropTypes.bool,
  tcLink: PropTypes.string.isRequired
};

export default TermsAndConditionsModal;
